
export const chartOptions = {
    scales: {
        x: {
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: true,
            grid: {
                display: false,
            },
        },
    },
    plugins: {
        
        legend: {
            display: true,
            position: "bottom" as const,
        },
        
    },
};
